export default __webpack_public_path__ + "static/media/mpn-picturemark-l.4135d09d.svg";